// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2M_TM","header":"MessagesList_header__3HXU-","chat":"MessagesList_chat__20pui"};